"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeURL = exports.normalizePublisherUrl = exports.isNumeric = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isNumeric = function isNumeric(value) {
  return !isNaN(value) && _typeof(value) !== "object" && value != Number.POSITIVE_INFINITY && value != Number.NEGATIVE_INFINITY;
};

exports.isNumeric = isNumeric;

var normalizePublisherUrl = function normalizePublisherUrl(computedUrl) {
  // console.log(`'${computedUrl}'`);
  var uri = [// special letters
  [new RegExp('[àáâãäå]', 'g'), 'a'], [new RegExp('[èéêë]', 'g'), 'e'], [new RegExp('[òóôõö]', 'g'), 'o'], [new RegExp('[ìíîï]', 'g'), 'i'], [new RegExp('[ùúûü]', 'g'), 'u'], [new RegExp('[æ]', 'g'), 'ae'], // url ending in '-/'
  [new RegExp('-/$'), '/'], // all non standard chars
  [/[^\x20-\x7E]+/g, '-'], // spaces
  [/ +/g, '-'], // punctuation
  [/\.+/g, '-'], [/,+/g, '-'], [/:+/g, '-'], [/;+/g, '-'], // quotation marks
  [/"+/g, '-'], [/'+/g, '-'], [/`+/g, '-'], [/’+/g, ''], // keyboard symbols
  [/\++/g, '-'], [/\|+/g, '-'], [/–+/g, '-'], [/\?+/g, '-'], [/!+/g, '-'], [/\*+/g, '-'], [/&+/g, '-'], [/\(+/g, '-'], [/\)+/g, '-'], [/\t+/g, '-'], [/°+/g, '-'], [/%+/g, '-'], [/\\+/g, '-'], // '-/' & '/-' occurrences
  [/-\/+/g, '-'], [/\/-+/g, '/'], // < & > occurrences
  [/<+/g, ''], [/>+/g, ''], // multiple dash occurrences
  [/-+/g, '-'], [/\@/g, ''], [/\#/g, ''], // ^ occurrences
  [/\^+/g, '']].reduce(function (buf, item) {
    return buf.replace(item[0], item[1]);
  }, computedUrl);

  if (uri.indexOf('/-') > -1) {
    uri = uri.split('/').filter(Boolean);

    var _uri = uri,
        _uri2 = _slicedToArray(_uri, 2),
        base = _uri2[0],
        slug = _uri2[1];

    var correctSlug = slug.replace(/-+/, '');
    uri = "/".concat(base, "/").concat(correctSlug);
  } // console.log(`'${uri}'`);


  return uri;
};

exports.normalizePublisherUrl = normalizePublisherUrl;

var normalizeURL = function normalizeURL(url) {
  return [// special letters
  [new RegExp('[àáâãäå]', 'g'), 'a'], [new RegExp('[èéêë]', 'g'), 'e'], [new RegExp('[òóôõö]', 'g'), 'o'], [new RegExp('[ìíîï]', 'g'), 'i'], [new RegExp('[ùúûü]', 'g'), 'u'], [new RegExp('[æ]', 'g'), 'ae'], // url ending in '-/'
  [new RegExp('-/$'), '/'], // all non standard chars
  [/[^\x20-\x7E]+/g, '-'], // spaces
  [/ +/g, '-'], // punctuation
  [/\.+/g, '-'], [/,+/g, '-'], [/:+/g, '-'], [/;+/g, '-'], // quotation marks
  [/"+/g, '-'], [/'+/g, '-'], [/`+/g, '-'], [/’+/g, ''], // keyboard symbols
  [/\++/g, '-'], [/\|+/g, '-'], [/–+/g, '-'], [/\?+/g, '-'], [/!+/g, '-'], [/\*+/g, '-'], [/&+/g, '-'], [/\(+/g, '-'], [/\)+/g, '-'], [/\t+/g, '-'], [/°+/g, '-'], // '-/' & '/-' occurrences
  [/-\/+/g, '-'], [/\/-+/g, '/'], // multiple dash occurrences
  [/-+/g, '-']].reduce(function (buf, item) {
    return buf.replace(item[0], item[1]);
  }, url);
};

exports.normalizeURL = normalizeURL;